import React from "react";
import ImageBanner from "@/components/ImageBanner";
import Card from "@/components/Card";
import Footer from "@/layout/Footer";
const Blog = () => {
	const blogStoryCard1 = [
		{
			imageUrl: "assets/blog/xl/image1.svg",
			title:
				"Transforming Dreams into Reality \n with Retail Arbitrage Dropshipping",
			description:
				"In the competitive world of e-commerce, success stories often begin with a combination of passion, perseverance, and the right tools. Meet Alex Bennett, an aspiring entrepreneur whose journey into online retailing took a significant leap forward with Retail Arbitrage (RA) Dropshipping software.",
			buttonLabel: "Read More",
			date: "Apr 10, 2025",
		},
	];
	const blogStoryCard2 = [
		{
			imageUrl: "assets/blog/xl/image2.svg",
			title:
				"Unleashing Potential: A Trailblazing Journey\n with Retail Arbitrage Dropshipping.",
			description:
				"In the dynamic world of e-commerce, taking opportunities and optimizing operations are essential for success. Meet Emily Chang, a creative entrepreneur whose journey into online retail was transformed by Retail Arbitrage (RA) Dropshipping software.",
			buttonLabel: "Read More",
			date: "Apr 10, 2025",
		},
	];
	const blogStoryCard3 = [
		{
			imageUrl: "assets/blog/xl/image3.svg",
			title:
				"Accelerating Growth: A Success\nStory with Retail Arbitrage Dropshipping",
			description:
				"In the dynamic world of online retail, seizing opportunities and optimizing operations are crucial for sustained success. Meet Sarah Thompson, whose entrepreneurial journey took a significant leap forward with Retail Arbitrage (RA) Dropshipping software.",
			buttonLabel: "Read More",
			date: "Apr 10, 2025",
		},
	];
	const blogStoryCard4 = [
		{
			imageUrl: "assets/blog/xl/image4.svg",
			title:
				"Revolutionizing E-commerce:\nThe Rise of AI-Powered Product Sourcing ",
			description:
				"In the fast-evolving landscape of e-commerce, staying ahead means embracing innovation that reshapes how businesses operate. Discover how AI-powered product sourcing is revolutionizing the industry and transforming the fortunes of entrepreneurs like never before.",
			buttonLabel: "Read More",
			date: "Apr 10, 2025",
		},
	];
	const blogStoryCard5 = [
		{
			imageUrl: "assets/blog/xl/image5.svg",
			title:
				"Empowering Single Mothers:\nA Journey to Successful Entrepreneurship",
			description:
				"In today's entrepreneurial landscape, single mothers are breaking barriers and achieving great success by harnessing their strength, resourcefulness, and entrepreneurial energy. ",
			buttonLabel: "Read More",
			date: "Apr 10, 2025",
		},
	];
	const blogStoryCard6 = [
		{
			imageUrl: "assets/blog/xl/image6.svg",
			title: "How to Start and Succeed in a\nFamily-Owned E-commerce Business",
			description:
				"Launching a business experience with family members can be a rewarding journey filled with unique challenges and opportunities. This blog explores the essential steps and practical tips for launching and growing a successful family-owned e-commerce business, promoting collaboration, and achieving long-term success.",
			buttonLabel: "Read More",
			date: "Apr 10, 2025",
		},
	];

	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Blog"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			<div className="hidden lg:flex relative flex-col w-[1194px] h-[406px] mt-[50px] mx-auto rounded-[5px] px-1 py-3 ">
				<Card variant="blogStoryCardTemplate1" content={blogStoryCard1[0]} />
			</div>
			<div className="hidden lg:flex relative flex-col w-[1194px] h-[406px] mx-auto rounded-[5px] px-1 py-3">
				<Card variant="blogStoryCardTemplate2" content={blogStoryCard2[0]} />
			</div>
			<div className="hidden lg:flex relative flex-col w-[1194px] h-[406px] mx-auto rounded-[5px] px-1 py-3">
				<Card variant="blogStoryCardTemplate1" content={blogStoryCard3[0]} />
			</div>
			<div className="hidden lg:flex relative flex-col w-[1194px] h-[406px] mx-auto rounded-[5px] px-1 py-3">
				<Card variant="blogStoryCardTemplate2" content={blogStoryCard4[0]} />
			</div>
			<div className="hidden lg:flex relative flex-col w-[1194px] h-[406px] mx-auto rounded-[5px] px-1 py-3">
				<Card variant="blogStoryCardTemplate1" content={blogStoryCard5[0]} />
			</div>
			<div className="hidden lg:flex relative flex-col w-[1194px] h-[406px] mx-auto rounded-[5px] px-1 py-3">
				<Card variant="blogStoryCardTemplate2" content={blogStoryCard6[0]} />
			</div>

			{/* Mobile view */}

			<ImageBanner type="mobile" title="Blog" />
			<div className="w-full lg:hidden flex flex-col px-2 my-8 gap-2">
				{/* Row 1: Sort By Button */}
				<div className="flex items-center justify-between">
					<button className="flex flex-row w-[122px] h-[32px] items-center justify-between border border-[#193D34] rounded-[24px] px-2 gap-2">
						<img
							loading="lazy"
							decoding="async"
							src="assets/product/mobile/sortIconStart.svg"
							alt="start icon"
							className="w-[16px] h-[16px]"
						/>
						<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34] text-center">
							Sort by
						</span>
						<img
							loading="lazy"
							decoding="async"
							src="assets/product/mobile/sortIconEnd.svg"
							alt="end icon"
							className="w-[16px] h-[16px]"
						/>
					</button>
				</div>

				{/* Row 2: Breadcrumbs */}
				<div className="flex items-center space-x-2 overflow-x-auto">
					{["Electronics", "Gadgets", "Cofee Machine"].map(
						(label, index, arr) => (
							<div key={index} className="flex items-center space-x-1">
								<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
									{label}
								</span>
								{index !== arr.length - 1 && (
									<img
										loading="lazy"
										decoding="async"
										src="assets/search/Icons/bread_crum_arrow.svg"
										alt="Arrow"
										className="w-[10px] h-[10px]"
									/>
								)}
							</div>
						)
					)}
				</div>
			</div>

			<div className="grid grid-cols-1 gap-10 lg:hidden">
				<Card variant="blogStoryCardTemplate1" content={blogStoryCard1[0]} />

				<Card variant="blogStoryCardTemplate2" content={blogStoryCard2[0]} />

				<Card variant="blogStoryCardTemplate1" content={blogStoryCard3[0]} />

				<Card variant="blogStoryCardTemplate2" content={blogStoryCard4[0]} />

				<Card variant="blogStoryCardTemplate1" content={blogStoryCard5[0]} />

				<Card variant="blogStoryCardTemplate2" content={blogStoryCard6[0]} />
			</div>
			<Footer />
		</>
	);
};

export default Blog;
